Number.prototype.clip = function (min, max) {
  return Math.max(min, Math.min(max, this));
};
